import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";
import schedule from '../employeesSchedules/schedule';

export default {
  name: 'Details',
  mixins: [validationMixin],
  components: {
    datetime: Datetime,
    DateTime,
    ElementComp: require('../../element.vue').default,
  },
  props: {
    dataObj: {
      require: true,
      type: Object
    },
  },
  data: function () {
    return {
      showDateDialog: false,
      appId: -1,
      bOnValidate: false,
      bShowTimeWarning: false,
      bCanChangeOriginDt: '',
      originDateTime: '',
      scheduledTo: '',
      startDt: '',
      endDt: '',
      maintenanceToElementType: [],
      maintenances: [],
      maintenance: { text: '', value: '' },
      conditions: [],
      condition: { text: '', value: '' },
      elementData: {
        elemenTypeDisabled: true,
        elementTypeId: -1,
        elementId: -1,
        readonly: false,
        maintenanceId: this.dataObj.appData.maintenanceId,
        lrsEventId: this.dataObj.appData.lrsEventId,
        lrsEventTypeId: this.dataObj.appData.lrsEventTypeId,
        jobcardId: this.dataObj.appData.jobcardId,
        availableLrsEventTypes: this.dataObj.appData.availableLrsEventTypes,
        appId: this.dataObj.appId,
        appKey: this.dataObj.appKey,
        elementName: '',
        capturedElement: {},
        enableElementFieldCapturing: this.dataObj.appData.settings.enableElementFieldCapturing
      },

      complainTypes: [],
      complainType: { text: '', value: '' },
      shifts: [],
      shift: { text: '', value: '' },
      groupCodes: [],
      groupCode: { text: '', value: '' },
      costCenters: [],
      costCenter: { text: '', value: '' },
      serviceTypes: [],
      serviceType: { text: '', value: '' },

      failureModes: [],
      failureMode: { text: '', value: '' },
      outcomes: [],
      notes: [],
      note: { text: '', value: '' },
      outcome: { text: '', value: '' },
      currentPage: 'details',
      message: '',
      deleteElementConfirmation: false,
      perviousElementName: '',
      askForDeleteCapturedElementDialog: false,
      askForDeleteCapturedElementData: {
        elementTypeId: -1,
        elementId: -1,
        maintenanceActivityValue: null
      }
    }
  },
  validations: {
    maintenanceValue: {
      required
    },
    conditionValue: {
      required
    },
    elementValue: {
      required
    },
  },
  computed: {
    originDateDisabled: function () {
      //console.log("scheduledTo",this.dataObj.appData.scheduledTo, " < originDt", this.dataObj.appData.originDt, ":", new Date(this.dataObj.appData.scheduledTo) < new Date(this.dataObj.appData.originDt));
      //console.log("originDt", this.dataObj.appData.originDt);
      // this.dataObj.appData.originDt != null && this.bCanChangeOriginDt && new Date(this.dataObj.appData.scheduledTo) < new Date(this.dataObj.appData.originDt) ? false : true

      return !(this.bCanChangeOriginDt === true);
    },
    outcomeId: function () {
      return this.dataObj.appData.outcomeId;
    },
    elementId: function () {
      return this.elementData.elementId;
    },
    elementTypeId: function () {
      return this.elementData.elementTypeId;
    },
    showTimeWarning() {
      var rc = false;
      if (this.dataObj.appData.scheduledTo < this.dataObj.appData.originDt)
        rc = true;
      if (this.dataObj.appData.startDt < this.dataObj.appData.originDt)
        rc = true;
      return rc;
    },
    maxDate: function () {
      return this.dataObj.allowInvstFutureDates ? null : moment().format();
    }
  },
  watch: {
    outcomeId: function (value) {
      this.dataObj.appData.OnlySave = value === 0;
    },
    elementTypeId: function (value) {
      this.dataObj.appData.elementTypeId = value;
    },
    condition: function (value) {
      if (!value)
        return;
      this.dataObj.appData.conditionId = value.value;
    },
    shift: function (value) {
      if (!value)
        return;
      this.dataObj.appData.shiftId = value.value;
    },
    costCenter: function (value) {
      if (!value)
        return;
      this.dataObj.appData.costCenterId = value.value;
    },
    groupCode: function (value) {
      if (!value)
        return;
      this.dataObj.appData.groupCodeId = value.value;
    },
    note: function (value) {
      if (!value)
        return;
      this.dataObj.appData.noteId = value.value;
    },
    outcome: function (value) {
      if (!value)
        return;
      this.dataObj.appData.outcomeId = value.value;
    },
    originDateTime: function (val) {
      this.dataObj.appData.originDt = moment(val).format();
      this.setWarningTime();
    },
    scheduledTo: function (val) {
      this.dataObj.appData.scheduledTo = moment(val).format();
      this.setWarningTime();
    },
    startDt: function (val) {
      this.dataObj.appData.startDt = moment(val).format();
      this.calculateActualJobDuration();
      this.setWarningTime();

      //this.checkDates(val);
    },
    endDt: function (val) {
      this.dataObj.appData.endDt = moment(val).format();
      this.calculateActualJobDuration();
    },
    serviceType: function (value) {
      if (!value)
        return;

      this.dataObj.appData.serviceTypeId = value.value;
    },
    "dataObj.appData.plannedJobDuration": function (value) {
      if (value < 0) {
        this.dataObj.appData.plannedJobDuration = 0;
        this.$forceUpdate();
      }
    },
    "dataObj.appData.plannedTravelDuration": function (value) {
      if (value < 0) {
        this.dataObj.appData.plannedTravelDuration = 0;
        this.$forceUpdate();
      }
    },
    "dataObj.appData.travelKm": function (value) {
      if (value < 0) {
        this.dataObj.appData.travelKm = 0;
        this.$forceUpdate();
      }
    },
    "dataObj.appData.actualTravelDuration": function (value) {
      if (value < 0) {
        this.dataObj.appData.actualTravelDuration = 0;
        this.$forceUpdate();
      }
    },
    "dataObj.appData.actualJobDuration": function (value) {
      if (value < 0) {
        this.dataObj.appData.actualJobDuration = 0;
        this.$forceUpdate();
      }
    },
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_jobcard_updated', this.init(false));
    this.$root.$on('omjobcard.validation.errors', this.validateActivity);

    this.init();
    setTimeout(() => {
      this.$watch('elementId', this.elementIdWatcher);
      this.$watch('maintenance', this.maintenanceWatcher);
      this.$watch('complainType', this.complainTypeWatcher);
      this.$watch('serviceType', this.serviceTypeWatcher);
      this.$watch('elementData.elementId', this.elementDataElementIdWatcher);
    }, 1000);
    //console.log("allow change date", this.bCanChangeOriginDt);
    console.log("details data", this.dataObj.appData);
    this.GetFieldElementType();
    this.perviousElementName = '';
  },
  mounted() {
    this.getElementTypeConditions();
  },
  methods: {
    checkDates(type) {
      if (!this.startDt)
        return;

      let start = moment(this.startDt);
      let scheduled = moment(this.scheduledTo);
      let origin = moment(this.originDateTime);

      if (start.isBefore(scheduled) || start.isBefore(origin) || scheduled.isBefore(origin)) {
        let dte;
        if (type == 'origin')
          dte = origin.format();
        else if (type == 'schedule')
          dte = scheduled.format();
        else
          dte = start.format();

        this.dataObj.appData.scheduledTo = dte;
        this.originDateTime = dte;
        this.scheduledTo = dte;
        this.dataObj.appData.originDt = dte;
        this.setWarningTime();

        this.$alertMsg(this.$t('jobcardDetail.DatesError'), 1);
      }
    },
    getElementTypeConditions() {
      this.conditions = this.dataObj.conditions;
      this.condition = this.dataObj.conditionId;

      //await axios.get('/OmActivityBase/GetElementTypeConditions?elementTypeId=' + this.dataObj.appData.elementTypeId + '&conditionId=' + this.dataObj.appData.conditionId)
      //  .then(response => {
      //    if (response.status == 200) {
      //      this.conditions = response.data;
      //      this.condition = this.conditions != null ? this.conditions.filter(p => p.selected)[0] : '';
      //      this.$forceUpdate();
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text);
      //      return;
      //    }
      //  })
      //  .catch(e => {
      //    console.log(e);
      //    this.$alertMsg(e.message);
      //  });
    },
    setWarningTime() {
      this.bShowTimeWarning = false;
      if (this.dataObj.appData.scheduledTo < this.dataObj.appData.originDt)
        this.bShowTimeWarning = true;
      if (this.dataObj.appData.startDt < this.dataObj.appData.originDt)
        this.bShowTimeWarning = true;
    },
    serviceTypeWatcher: function (value) {
      if (!value)
        return;
      this.dataObj.appData.serviceTypeId = value.value;
      if (this.dataObj.appData.serviceTypeToStation && this.dataObj.appData.isStationByServiceType === true) {
        var stationId = this.dataObj.appData.serviceTypeToStation[value.value];
        if (stationId) {
          const newStation = this.stations.filter(p => p.value === stationId.toString()) && this.stations.filter(p => p.value === stationId.toString()).length > 0 ? this.stations.filter(p => p.value === stationId.toString())[0] : null;
          this.station = newStation ? newStation : { text: '', value: '' };
        }
        else
          this.station = { text: '', value: '' };
      }
    },
    complainTypeWatcher: function (value) {
      if (!value)
        return;
      this.dataObj.appData.complainTypeId = value.value;
      this.maintenance = null;
      this.getMaintenanceActivities();
    },
    elementDataElementIdWatcher: function (value) {
      //console.log("element", value);

      if (!value || parseInt(this.dataObj.appData.elementId) === parseInt(value.value))
        return;

      this.dataObj.appData.elementId = value;

      if (this.dataObj.appData.maintenanceId > 0 && this.dataObj.appData.elementId > 0 && parseInt(value) > 0)
        this.onElementOrMaintenanceChange();
    },
    elementIdWatcher: function (value) {
      if (value == this.dataObj.appData.elementId)
        return;

      this.dataObj.appData.elementId = value;
    },
    maintenanceWatcher: function (value) {
      if (!value || parseInt(this.dataObj.appData.maintenanceId) === parseInt(value.value))
        return;

      if (this.$refs.elementComponent != null && this.$refs.elementComponent.createdJobCardElementId > -1) {
        this.checkCanDeleteCapturedElement(this.$refs.elementComponent.dataObj.elementTypeId, this.$refs.elementComponent.createdJobCardElementId, value);
      } else {
        this.maintenanceWatcherAction(value);
      }
    },
    maintenanceWatcherAction(value) {
      this.dataObj.appData.maintenanceId = value.value;
      this.resetElementData();
      this.elementData.elementTypeId = this.dataObj.appData.maintenanceToElementType[this.dataObj.appData.maintenanceId];
      if (this.dataObj.appData.maintenanceId > 0 && parseInt(value.value) > 0)
        this.onElementOrMaintenanceChange(true);
      // this.getMaintenanceActivities();
      if (!this.dataObj.appData.maintenanceToElementType)
        this.dataObj.appData.maintenanceToElementType = this.maintenanceToElementType;

      //console.log(this.elementData);
      this.$root.$emit('element_data_updated');
    },
    checkCanDeleteCapturedElement(typeId, id, newValue) {
      const params = {
        ApplicationId: this.appId,
        elementTypeId: typeId,
        elementId: id
      }

      axios.post('/OmJobcardActivity/CanDeleteElement', params)
        .then(response => {
          if (response.data) {
            this.askForDeleteCapturedElementData = {
              elementTypeId: typeId,
              elementId: id,
              maintenanceActivityValue: newValue
            };

            this.askForDeleteCapturedElementDialog = true;
          } else {
            this.maintenanceWatcherAction(newValue);
          }
        })
        .catch(e => {
          console.log(e);
          this.$alertMsg(e.message);
        });
    },
    dontDeleteCapturedElement() {
      this.askForDeleteCapturedElementDialog = false;
      this.$refs.elementComponent.createdJobCardElementId = -1;
      this.maintenanceWatcherAction(this.askForDeleteCapturedElementData.maintenanceActivityValue);
    },
    deleteCapturedElement() {
      const params = {
        ApplicationId: this.appId,
        elementTypeId: this.askForDeleteCapturedElementData.elementTypeId,
        elementId: this.askForDeleteCapturedElementData.elementId
      }

      axios.post('/OmJobcardActivity/DeleteElement', params)
        .then(response => {
          this.askForDeleteCapturedElementDialog = false;
          this.$refs.elementComponent.createdJobCardElementId = -1;
          this.maintenanceWatcherAction(this.askForDeleteCapturedElementData.maintenanceActivityValue);
        })
        .catch(e => {
          console.log(e);
          this.$alertMsg(e.message);
        });

      this.askForDeleteCapturedElementDialog = false;
      this.$refs.elementComponent.createdJobCardElementId = -1;
      this.maintenanceWatcherAction(this.askForDeleteCapturedElementData.maintenanceActivityValue);
    },
    async GetFieldElementType() {
      return;
      //console.log("GetFieldElementType", this.dataObj.appData.elementTypeId);

      if (this.dataObj.appData.elementTypeId < 0) {
        this.dataObj.appData.settings.enableElementFieldCapturing = true;
        return;
      }

      await axios.get('/Element/GetFieldElementType?elementTypeId=' + this.dataObj.appData.elementTypeId)
        .then(response => {
          //console.log("resp", response)
          if (response == null) {
            this.dataObj.appData.settings.enableElementFieldCapturing = false;
          }
          else {
            this.dataObj.appData.settings.enableElementFieldCapturing = true;
          }
        })
        .catch(e => {
          console.log(e);
          this.$alertMsg(e.message);
        });
    },
    resetElementData() {
      this.dataObj.appData.elementId = -1;
      //this.elementTypeId = '';
      this.elementData =
      {
        elemenTypeDisabled: true,
        elementTypeId: -1,
        elementId: -1,
        elementName: '',
        readonly: false,
        maintenanceId: this.dataObj.appData.maintenanceId,
        lrsEventId: this.dataObj.appData.lrsEventId,
        lrsEventTypeId: this.dataObj.appData.lrsEventTypeId,
        jobcardId: this.dataObj.appData.jobcardId,
        availableLrsEventTypes: this.dataObj.appData.availableLrsEventTypes,
        appId: this.dataObj.appId,
        appKey: this.dataObj.appKey,
        enableElementFieldCapturing: this.dataObj.appData.settings.enableElementFieldCapturing
      }
      this.$root.$emit('maintenance_activity_changed');
    },
    calculateActualJobDuration() {
      var startTime = new Date(this.dataObj.appData.startDt);
      var endTime = new Date(this.dataObj.appData.endDt);
      var difference = endTime.getTime() - startTime.getTime();
      var minutes = Math.round(difference / 60000);
      this.dataObj.appData.actualJobDuration = !minutes ? 0 : minutes;
    },
    validateActivity() {
      this.bOnValidate = true;
      setTimeout(() => {
        var xEl = document.getElementsByClassName('activity-field-error');
        if (xEl.length > 0)
          xEl[0].scrollIntoView({ behavior: 'smooth', block: 'end' });
      }, 100);
    },
    init(addComplaintTypes = false) {
      Vue.nextTick(() => {
        this.dataObj.appData.OnlySave = this.dataObj.appData.outcomeId === 0;
        this.bCanChangeOriginDt = this.dataObj.appData.settings.allowToModifyOriginDt;
        //console.log("bbb", this.bCanChangeOriginDt );
        this.originDateTime = this.dataObj.appData.originDt == null ? '' : this.dataObj.appData.originDt;
        this.scheduledTo = this.dataObj.appData.scheduledTo;
        this.startDt = this.dataObj.appData.startDt;
        this.endDt = this.dataObj.appData.endDt;
        this.appId = this.dataObj.appId;
        this.maintenanceToElementType = this.dataObj.maintenanceToElementType;

        this.dataObj.appData.maintenances.sort((a, b) => (a.text > b.text) ? 1 : -1);
        this.maintenances = this.dataObj.appData.maintenances;
        if (this.maintenances && this.maintenances.length > 0)
          this.maintenance = this.maintenances.filter(p => p.value == this.dataObj.appData.maintenanceId)[0];
        this.conditions = this.dataObj.appData.conditions;
        if (this.conditions && this.conditions.length > 0)
          this.condition = this.conditions.filter(p => p.value == this.dataObj.appData.conditionId)[0];

        this.shifts = this.dataObj.appData.shifts;
        if (this.shifts && this.shifts.length > 0)
          this.shift = this.shifts.filter(p => p.value == this.dataObj.appData.shiftId)[0];
        this.groupCodes = this.dataObj.appData.groupCodes;
        if (this.groupCodes && this.groupCodes.length > 0)
          this.groupCode = this.groupCodes.filter(p => p.value == this.dataObj.appData.groupCodeId)[0];
        this.costCenters = this.dataObj.appData.costCenters;
        if (this.costCenters && this.costCenters.length > 0)
          this.costCenter = this.costCenters.filter(p => p.value == this.dataObj.appData.costCenterId)[0];
        this.serviceTypes = this.dataObj.appData.serviceTypes;
        if (this.serviceTypes && this.serviceTypes.length > 0)
          this.serviceType = this.serviceTypes.filter(p => p.value == this.dataObj.appData.serviceTypeId)[0];

        this.failureModes = this.dataObj.appData.failureModes;
        if (this.failureModes && this.failureModes.length > 0)
          this.failureMode = this.failureModes.filter(p => p.value == this.dataObj.appData.failureModeId)[0];
        this.outcomes = this.dataObj.appData.jcOutcomes;
        this.notes = this.dataObj.appData.notes;
        if (this.notes && this.notes.length > 0)
          this.note = this.notes.filter(p => p.value == this.dataObj.appData.noteId)[0];

        if (this.outcomes && this.outcomes.length > 0)
          this.outcome = this.outcomes.filter(p => p.value == this.dataObj.appData.outcomeId)[0];

        if (this.dataObj.appData.maintenanceId > 0 && this.dataObj.appData.maintenanceToElementType) {
          this.elementData.elementTypeId = this.dataObj.appData.elementTypeId;//this.dataObj.appData.maintenanceToElementType[this.dataObj.appData.maintenanceId];
          this.elementData.elementId = this.dataObj.appData.elementId;
          this.elementData.elementRef = this.dataObj.appData.elementRef;
          this.$root.$emit('element_data_updated');
        }

        if (this.dataObj.appData.settings.employeeServiceTypeId && this.dataObj.appData.settings.employeeServiceTypeId > 0)
          this.serviceType = this.serviceTypes.filter(p => p.value == this.dataObj.appData.settings.employeeServiceTypeId)[0];

        this.dataObj.appData.complainTypes.sort((a, b) => (a.text > b.text) ? 1 : -1);

        if (this.complainTypes)
          this.complainTypes = this.dataObj.appData.complainTypes;

        if (this.complainTypes && this.complainTypes.length > 0) {
          this.complainType = this.complainTypes.filter(p => p.value == this.dataObj.appData.complainTypeId)[0];
        }

        if (!this.dataObj.appData.omAllowServTypeSelNoLinkFaultCode && this.serviceType && this.serviceType.value > -1 && this.complainTypes)
          this.complainTypes = this.complainTypes.filter(p => p.group.id === this.serviceType.value);

        this.elementData.readonly = this.dataObj.readOnly;

        this.$forceUpdate();
      });
    },
    onTimeChanged(val) {
      this[val.var] = val.time;
    },
    setSelectedMActivity(code) {
      //console.log(code);
      var elementType = this.dataObj.appData.maintenanceToElementType[code];
      //this.getElements(elementType);
    },
    setSelectedCondition(code) {
      //console.log(code);
    },
    setSelectedElement(code) {
      //console.log(code);
    },
    setSelectedFailureMode(code) {
      //console.log(code);
    },
    setSelectedOutcome(code) {
      //console.log(code);
    },
    setSelectedNote(code) {
      //console.log(code);
    },
    setSelectedCType(code) {
      //console.log(code);
    },
    setSelectedShift(code) {
      //console.log(code);
    },
    setSelectedGroupCode(code) {
      //console.log(code);
    },
    setSelectedCostCenter(code) {
      //console.log(code);
    },
    setSelectedSTypes(code) {
      //console.log(code);
    },
    getMaintenanceActivities() {
      //if (!this.dataObj.appData.maintenanceId || parseInt(this.dataObj.appData.maintenanceId) == 0)
      //  return;
      var parameters = {
        complainTypeId: parseInt(this.dataObj.appData.complainTypeId),
        serviceTypeId: this.serviceType ? this.serviceType.value : null,
        currentlySelectedMaintenanceId: parseInt(this.dataObj.appData.maintenanceId) > 0 ? parseInt(this.dataObj.appData.maintenanceId) : null,
      };
      this.$store.state.notifier.asyncBlock(
        axios.get('/OmActivityBase/GetMaintenanceActivities', { params: parameters }),
        response => {
          if (response.status == 200) {
            this.maintenances = response.data;
          }
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text),
        'Loading Maintenances'
      );
    },
    onElementOrMaintenanceChange(resetElementId) {
      var parameter = {
        MaintenanceId: parseInt(this.dataObj.appData.maintenanceId),
        ElementTypeId: this.elementTypeId,
        ElementId: this.dataObj.appData.elementId != null ? this.dataObj.appData.elementId : 0,
        ApplicationId: this.appId
      };


      axios.post('/OmJobcardActivity/OnElementOrMaintenanceChange', parameter)
        .then(response => {
          if (response.status == 200) {
            //Update steps
            this.dataObj.appData.steps = response.data.item.steps != null && response.data.item.steps.length > 0 ? response.data.item.steps : [];
            //console.log("steps", this.dataObj.appData.steps);

            response.data.item.OnlySave = this.dataObj.appData.OnlySave;
            this.dataObj.appData.lrsEventId = response.data.item.lrsEventId;
            this.dataObj.appData.lrsEventTypeId = response.data.item.lrsEventTypeId;

            this.dataObj.appData.elementTypeId = response.data.item.elementTypeId;
            this.dataObj.appData.elementComment = response.data.item.elementComment;
            this.elementData.elementTypeId = response.data.item.elementTypeId;

            this.GetFieldElementType();

            this.elementData.elementId = resetElementId ? 0 : response.data.item.elementId;
            this.elementData.readonly = this.dataObj.readOnly;
            this.$root.$emit('element_data_updated');
            this.$root.$emit('om_jobcard_updated');
            this.dataObj.appData.steps = response.data.item.steps;

            //this.dataObj.appData.plannedJobDuration = response.data.item.plannedJobDuration;
            //this.dataObj.appData.plannedTravelDuration = response.data.item.plannedTravelDuration;
            //this.dataObj.appData.travelKm = response.data.item.travelKm;
            //this.dataObj.appData.actualTravelDuration = response.data.item.actualTravelDuration;
            //this.dataObj.appData.actualJobDuration = response.data.item.actualJobDuration;

            this.dataObj.appData.actualManpowerUsages = response.data.item.actualManpowerUsages;
            this.dataObj.appData.actualSupportUsages = response.data.item.actualSupportUsages;
            this.dataObj.appData.comment = response.data.item.comment;



            //if (response.data.item.complainTypeId > 0)
            //  this.dataObj.appData.complainTypeId = response.data.item.complainTypeId;
            this.dataObj.appData.conditionComment = response.data.item.conditionComment;
            this.dataObj.appData.conditionId = response.data.item.conditionId;
            this.dataObj.appData.consumables = response.data.item.consumables;
            this.dataObj.appData.costCenterId = response.data.item.costCenterId;
            this.dataObj.appData.deadline = response.data.item.deadline;
            this.dataObj.appData.failureModeId = response.data.item.failureModeId;
            this.dataObj.appData.groupCodeId = response.data.item.groupCodeId;
            this.dataObj.appData.hasDeadline = response.data.item.hasDeadline;
            this.dataObj.appData.maintenanceId = response.data.item.maintenanceId;
            this.dataObj.appData.markedPositionX = response.data.item.markedPositionX;
            this.dataObj.appData.markedPositionY = response.data.item.markedPositionY;
            this.dataObj.appData.noteId = response.data.item.noteId;
            this.dataObj.appData.originDt = response.data.item.originDt;
            this.dataObj.appData.outcomeId = response.data.item.outcomeId;

            //this.dataObj.appData.startDt = response.data.item.startDt;
            //this.dataObj.appData.endDt = response.data.item.endDt;

            this.dataObj.appData.scheduledTo = response.data.item.scheduledTo;
            this.dataObj.appData.serviceTypeId = response.data.item.serviceTypeId;
            this.dataObj.appData.shiftId = response.data.item.shiftId;
            this.dataObj.appData.stores = response.data.item.stores;

            this.getElementTypeConditions();
            //var clearedAll = response.data.clearedAll;

          }
        })
        .catch(err => this.$alertMsg(err.data.data.text));
    },
  },
}
